/* unplugin-vue-components disabled */import { render } from "./external-modal.vue?vue&type=template&id=e23b6624&scoped=true"
import script from "./external-modal.vue?vue&type=script&lang=js"
export * from "./external-modal.vue?vue&type=script&lang=js"

import "./external-modal.vue?vue&type=style&index=0&id=e23b6624&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e23b6624"],['__file',"src/components/external-link/external-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e23b6624"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e23b6624', __exports__)) {
    api.reload('e23b6624', __exports__)
  }
  
  module.hot.accept("./external-modal.vue?vue&type=template&id=e23b6624&scoped=true", () => {
    api.rerender('e23b6624', render)
  })

}


export default __exports__